import Vue from 'vue';
import Router from 'vue-router';

Vue.use( Router );

let appRouter = new Router({
    mode: 'history',
    routes: [
        // generated-routes,
        {
            path: '/mail',
            name: 'IntroVideo',
            component: () =>
            {
                return import( /* webpackChunkName: "scroller" */ '@/app/pages/IntroVideo' );
            }
        },
        {
            path: '/:name?/:sub?',
            name: 'Scroller',
            component: () =>
            {
                return import( /* webpackChunkName: "scroller" */ '@/app/components/Scroller' );
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    next();
});

export default appRouter;
